export function downloadCsv(filename, rows, columns) {
  const esc = (v) => {
    const s = v === null || v === undefined ? "" : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = columns.map(c => esc(c.label)).join(",");
  const body = rows.map(r => columns.map(c => esc(r[c.key])).join(",")).join("\n");
  const csv = `${header}\n${body}`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const VULN_COLUMNS = [
  { key: "id", label: "ID" },
  { key: "title", label: "Titre" },
  { key: "host", label: "Hote" },
  { key: "port", label: "Port" },
  { key: "service", label: "Service" },
  { key: "severity", label: "Severite" },
  { key: "cvss", label: "CVSS" },
  { key: "source", label: "Source" },
  { key: "state", label: "Etat" },
  { key: "matched_at", label: "Chemin/URL" },
  { key: "scanned_at", label: "Date" },
];
